export const getImageResponseToCache = async (url: string) => {
  try {
    const headResponse = await fetch(url, { method: 'HEAD' });
    if (!headResponse.ok) {
      return;
    }

    const response = await fetch(url);
    if (!response.ok) {
      return;
    }

    return response.clone();
  } catch (error) {
    console.error('getImageResponseToCache', error);
  }
};
